import { isDate, isNumber, isString } from "lodash";

// Get user's current timezone
export const getUserTimezone = (): string => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

// Get timezone offset in minutes
export const getTimezoneOffset = (): number => {
  return new Date().getTimezoneOffset();
};

// Format date with timezone information
export const formatDateWithTimezone = (date: Date): string => {
  const timezone = getUserTimezone();
  const offset = getTimezoneOffset();
  const offsetHours = Math.floor(Math.abs(offset) / 60);
  const offsetMinutes = Math.abs(offset) % 60;
  const offsetSign = offset <= 0 ? '+' : '-';
  
  // Format the date in user's timezone
  const formattedDate = date.toLocaleDateString('en-US', {
    timeZone: timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
  
  // Format the time in user's timezone
  const formattedTime = date.toLocaleTimeString('en-US', {
    timeZone: timezone,
    hour: '2-digit',
    minute: '2-digit',
    hour12: false
  });
  
  const offsetString = `${offsetSign}${offsetHours.toString().padStart(2, '0')}:${offsetMinutes.toString().padStart(2, '0')}`;
  
  return `${formattedDate} ${formattedTime} (${timezone}, UTC${offsetString})`;
};

export const dateValueGetter = (value: any) => {
  if (isDate(value)) {
    return value;
  }

  let result = undefined;

  if (
    (isString(value) && !!value) ||
    (isNumber(value) && !isNaN(parseInt(value.toString(), 10)))
  ) {
    try {
      result = new Date(value);
      if (!isDate(result)) {
        result = undefined;
      }
    } catch {
      result = undefined;
    }
  }

  return result;
};